import React from 'react';
const WhyRAG = () => {
    return (
        <div
            className="section-py bg-grey dark:bg-black border-b"
            style={{
                borderImageSource: 'linear-gradient(270deg, rgba(60, 69, 97, 0) 0%, #3C4561 50%, rgba(60, 69, 97, 0) 100%)',
                borderImageSlice: 1,
            }}
        >
            <div className="container xl:container mx-auto">
                <div className="row grid lg:grid-cols-12">
                    <div className="lg:col-span-6">
                        <h2 className="text-primary mb-4" data-aos="fade-up" data-aos-duration="700" data-aos-delay="100">
                            Why RAG & Conversational AI now
                        </h2>
                        <p
                            className="text-secondary mb-0 dark:text-[#D7DEE5]"
                            data-aos="fade-up"
                            data-aos-duration="700"
                            data-aos-delay="200"
                        >
                            Organizations are flooded with unstructured information scattered across emails, documents, CRM logs,
                            and knowledge repositories. Retrieval-Augmented Generation (RAG) and LLMs for enterprise are
                            transforming this chaos into intelligent, accessible insights.
                        </p>
                    </div>
                    <div className="lg:col-span-6">
                        <p className="mb-4 dark:text-[#D7DEE5]"
                        data-aos="fade-up"
                            data-aos-duration="700"
                            data-aos-delay="200">
                            Businesses are using Conversational AI to automate support, augment employees with knowledge bots, and
                            accelerate enterprise decisions. The rise of frameworks like LangChain, LangSmith, and MCP has made
                            secure integrations and MLOps partner for enterprise easier than ever.
                        </p>
                        <p className="mb-0 dark:text-[#D7DEE5]"
                        data-aos="fade-up"
                            data-aos-duration="700"
                            data-aos-delay="200">
                            Now, enterprises can deploy RAG-based assistants, semantic search tools, and enterprise LLM chatbot
                            development that deliver measurable performance and compliance, bridging human knowledge with machine
                            intelligence in real time.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
};
export default WhyRAG;
